import React, { useState, useRef, useEffect } from "react";
import "./styles.scss";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import axios from 'util/axios';
import ModalPortal from "util/component/Modal";
import { Confirm, Modal } from "util/component/Modal/Modal";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faThumbtack } from "@fortawesome/free-solid-svg-icons";

import { useTranslation } from "react-i18next";

import Editor from "ckeditor5-custom-build/build/ckeditor";
import { CKEditor } from "@ckeditor/ckeditor5-react";

const getDateFormat = (date, delim = "-") => {
    const leftPad = (v) => {
        v = parseInt(v);

        if (v >= 10) {
            return v;
        } else {
            return `0${v}`;
        }
    };
    const year = date.getFullYear();
    const month = leftPad(date.getMonth() + 1);
    const day = leftPad(date.getDate());
    return [year, month, day].join(delim);
};
const setDateFormat = (dateStr) => {
    if (!dateStr) return null;
    const str = dateStr.replace(/(\d{4}).*(\d{,2}).*(\d{,2})/, "$1-$2-$3");
    return new Date(str);
};

const initialContent = {
    noticeTitle: "",
    startDt: getDateFormat(new Date()),
    endDt: null,
    fileNm: null,
    noticeContent: "",
    fileFlag: false,
    fixYn: 0,
    target: "",
};

const CustomInput = (props) => {
    const [_value, _setValue] = useState(props.value);

    const _onChange = (e) => {
        let _val = e.target.value;
        _setValue(_val);
    };

    const _onBlur = (e) => {
        props.onChange(e);
    };

    useEffect(() => {
        _setValue(props.value);
    }, [props]);

    return (
        <input
            {...props}
            style={{ border: "none", outline: "none" }}
            value={_value}
            onChange={_onChange}
            disabled={props.disabled}
            onBlur={_onBlur}
        />
    );
};

const App = () => {
    const { t } = useTranslation(["page"]);
    const [MainValue, SetMainValue] = useState(initialContent);
    const [ModalOpen, SetModalOpen] = useState(false);
    const [ModalOpen2, SetModalOpen2] = useState(false);
    const [ModalOpen3, SetModalOpen3] = useState(false);
    const fileRef = useRef(null);
    const quillValue = useRef();
    const FileSelect = () => {
        fileRef.current.click();
    };
    const selector = useSelector((store) => store.user);
    const navigator = useNavigate();

    const getData = async (noticeId) => {
        let response = await axios
            .post(process.env.REACT_APP_API + "/notice/retrieveNotice", { noticeId: noticeId })
            .then((Response) => Response.data.data.result);

        SetMainValue((MV) => ({ ...MV, ...response }));
    };

    const fileHandler = (e) => {
        const file = e?.target?.files[0] ?? null;
        SetMainValue((i) => ({ ...i, fileNm: file, fileFlag: true }));
    };

    const params = useParams();
    useEffect(() => {
        if (!!params.noticeId) getData(params.noticeId);
    }, []);

    useEffect(() => {
        quillValue.current?.setData(MainValue.noticeContent)
    }, [MainValue]);

    const formSubmit = () => {
        const validation = (valiData) => {
            let flag = true;
            if (!!!valiData.noticeTitle) flag = false;
            return flag;
        };
        if (validation(MainValue)) {
            const formData = new FormData();
            for (let v of Object.keys(MainValue)) {
                let name = v;
                let value;
                if (name === "noticeContent") value = quillValue.current.getData();
                else value = MainValue[v];
                formData.append(name, value);
            }
            formData.append("userId", selector.userId);
            let isUpdate = !!Object.keys(MainValue).find((e) => e === "noticeId");
            sendData(formData, isUpdate);
        } else {
            SetModalOpen2(true);
        }
    };

    const sendData = async (formData, isUpdate) => {
        const url = isUpdate ? "/notice/modifyNotice" : "/notice/createNotice";

        const response = await axios
            .post(process.env.REACT_APP_API + url, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            })
            .then((Response) => Response.data.data.result)
            .catch((Error) => console.error(Error));
        if (response === 1) {
            navigator(-1);
        } else {
            window.alert("Error");
        }
    };

    const delHandler = async () => {
        const noticeId = MainValue.noticeId;
        const url = process.env.REACT_APP_API + "/notice/removeNotice";
        const response = await axios.post(url, { noticeId: noticeId }).then((Response) => Response.data.data.result);
        if (response === 1) {
            navigator(-1);
        } else {
            window.alert("ERROR");
        }
    };

    return (
        <div className="bpl-container">
            <section className={"admin_noticeWrite"}>
                <div className="top">
                    <h3 className="list_name">Notice</h3>
                </div>

                <div className="bottom">
                    <table>
                        <tbody>
                            <tr>
                                <td>Title</td>
                                <td>
                                    <div style={{ display: "flex" }}>
                                        <div style={{ flex: 3 }}>
                                            <CustomInput
                                                onChange={(e) => SetMainValue((i) => ({ ...i, noticeTitle: e.target.value }))}
                                                value={MainValue.noticeTitle}
                                                name={"noticeTitle"}
                                                placeholder={"Title"}
                                                type={"text"}
                                            />
                                        </div>
                                        <div style={{ flex: 1, display: "flex", alignItems: "center" }}>
                                            <input
                                                type="checkbox"
                                                id="fix"
                                                style={{ width: "20px", height: "20px" }}
                                                checked={MainValue.fixYn > 0}
                                                onChange={(e) =>
                                                    SetMainValue((MV) => ({ ...MV, fixYn: e.target.checked ? 1 : 0 }))
                                                }
                                            />
                                            <label htmlFor="fix" className="pin" style={{ flex: 1, marginLeft: "10px" }}>
                                                <FontAwesomeIcon icon={faThumbtack} />
                                            </label>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>Date</td>
                                <td>
                                    <div className="datePicker-box">
                                        <div className="datePicker-item">
                                            <DatePicker
                                                dateFormat="Y.M.dd"
                                                selected={setDateFormat(MainValue.startDt)}
                                                onChange={(d) => SetMainValue((i) => ({ ...i, startDt: getDateFormat(d) }))}
                                            />
                                        </div>
                                        <div className="datePicker-item">
                                            <DatePicker
                                                dateFormat="Y.M.dd"
                                                selected={setDateFormat(MainValue.endDt)}
                                                onChange={(d) => SetMainValue((i) => ({ ...i, endDt: getDateFormat(d) }))}
                                            />
                                        </div>
                                    </div>
                                </td>
                            </tr>

                            <tr>
                                <td>Target</td>
                                <td>
                                    <div className="d-flex gap-10">
                                        <label>
                                            <input
                                                type="radio"
                                                name="target"
                                                value={""}
                                                checked={MainValue.target === ""}
                                                onChange={(e) => SetMainValue((i) => ({ ...i, target: e.target.value }))}
                                            />{" "}
                                            All
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="target"
                                                value={"I"}
                                                checked={MainValue.target === "I"}
                                                onChange={(e) => SetMainValue((i) => ({ ...i, target: e.target.value }))}
                                            />{" "}
                                            Internal Only
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="target"
                                                value={"E"}
                                                checked={MainValue.target === "E"}
                                                onChange={(e) => SetMainValue((i) => ({ ...i, target: e.target.value }))}
                                            />{" "}
                                            External Only
                                        </label>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>File</td>
                                <td>
                                    <button className="file" onClick={FileSelect}>
                                        {t("fileSelect")}
                                    </button>
                                    <input type="file" className="d-none" ref={fileRef} onChange={fileHandler} />
                                    {MainValue.fileNm && (
                                        <div className={"fileBox"}>
                                            <span style={{ marginLeft: "10px" }}>
                                                {MainValue.fileNm?.name ?? MainValue.fileNm}
                                            </span>
                                            <span className="delbtn" onClick={() => SetModalOpen(true)}>
                                                X
                                            </span>
                                        </div>
                                    )}
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan="2">Content</td>
                            </tr>
                            <tr>
                                <td colSpan="2" className="ck-editor-wrapper">
                                    {/* <QuillComponent ref={quillValue} value={MainValue.noticeContent} /> */}
                                    <CKEditor
                                        editor={Editor}
                                        watchdogConfig={{ crashNumberLimit: 10 }}
                                        onReady={(editor) => {
                                            window.editor = editor;

                                            editor.setData(MainValue.noticeContent);
                                            quillValue.current = editor;
                                        }}
                                    />
                                    {/* <ReactQuillComponent ref={quillValue} value={MainValue.noticeContent} /> */}
                                </td>
                            </tr>
                        </tfoot>
                    </table>

                    <div className="bottom">
                        <div className="btn_box">
                            <div className="btn">
                                <span onClick={formSubmit}>Save</span>
                            </div>
                            <div className="btn">
                                <span onClick={() => navigator(-1)}>Cancel</span>
                            </div>
                            {!!Object.keys(MainValue).find((e) => e === "noticeId") && (
                                <div className="btn del_btn">
                                    <span onClick={() => SetModalOpen3(true)}>Delete</span>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </section>
            {ModalOpen && (
                <ModalPortal>
                    <Confirm onClose={() => SetModalOpen(false)} onConfirm={() => fileHandler()}>
                        <p>{t("file") + t("is3") + " " + t("delete")}</p>
                    </Confirm>
                </ModalPortal>
            )}
            {ModalOpen2 && (
                <ModalPortal>
                    <Modal onClose={() => SetModalOpen2(false)}>
                        <p>{t("title") + t("is1") + " " + t("required")}</p>
                    </Modal>
                </ModalPortal>
            )}
            {ModalOpen3 && (
                <Confirm onClose={() => SetModalOpen3(false)} onConfirm={() => delHandler()}>
                    <p>{t("delete")}</p>
                </Confirm>
            )}
        </div>
    );
};

export default App;
